import React from 'react';
import  { Link } from 'react-router-dom';
import ReactDOM from 'react-dom';

import {
  Row,
  Col,
  Card,  
  CardBody,
  Button,
  Form,
  FormGroup,
  Label,
  Input,
  // CardHeader,
  // FormText,
  // FormFeedback,
} from 'reactstrap';
import {
  // MdCreate,
  // MdDelete,
  // MdRemoveRedEye,
  // MdLaunch,
  // MdAdd,
  MdFileUpload
} from 'react-icons/md';
import Page from 'components/Page';
import axios from 'axios';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import NumberFormat from 'react-number-format';
import AppConstants from 'AppConstants';
import {ReactTitle} from 'react-meta-tags';
import Loading from 'assets/img/loader.gif';
import placeholderimg from './../assets/img/placeholder.png';
import { getProfile,updateProfile } from 'actions/authentication';
class Editprofile extends React.Component {
  constructor(props){
    super(props);
    this.state = {
      _id:this.props.auth.user._id,
      user_type:this.props.auth.user.user_type,
      firstname:'',
      lastname:'',      
      email:'',
      profile_image:null,
      prev_logo: '',
      view_logo: '',
      old_img:'',
      address1:'',
      //country:'',
      state:'',      
      city:'',
      file: null,
      //address2:'',
      zipcode:'',
      phone:'',
      //gender:'',     
      errors: {},
      //errMsg:'',
      errMsg:false,
      loading: ''
    }
    this.handleSubmit = this.handleSubmit.bind(this);  
    this.handleInputChange = this.handleInputChange.bind(this); 
    this.onChangeNumberkey = this.onChangeNumberkey.bind(this);
    this.handleProfileImage = this.handleProfileImage.bind(this);
    this.inputChangedHandlerContact = this.inputChangedHandlerContact.bind(this); 
    this.handleKeyUp = this.handleKeyUp.bind(this); 

  }
  inputChangedHandlerContact = (values) => {
    this.setState({
      phone: values.value,
    });
  }
  
  handleProfileImage(e) {
       this.setState({
			[e.target.name]:e.target.files[0],
			old_img:'',
			prev_logo:URL.createObjectURL(e.target.files[0])
			
		});
	}
  onChangeNumberkey(e){
		const states = this.state
		const re = /^[0-9\b]+$/;
		if (e.target.value === '' || re.test(e.target.value)) {
		states[e.target.name] = e.target.value;
		this.setState({states})
		}
	}
  handleInputChange(e) {
    this.setState({
        [e.target.name]: e.target.value
    });
  }

  handleKeyUp(e){
    let errors = {};
    let formIsValid = true;
    if(!this.state.firstname){
      formIsValid = false;
      errors["firstname"] = "Please enter first name";     

    }
    if(!this.state.lastname){
      formIsValid = false;
      errors["lastname"] = "Please enter last  name";

    }
    if(!this.state.address1){
      formIsValid = false;
      errors["address1"] = "Please enter address";

    }
    if(!this.state.state){
      formIsValid = false;
      errors["state"] = "Please enter state";

    }
    if(!this.state.city){
      formIsValid = false;
      errors["city"] = "Please enter city";

    }
    if(!this.state.zipcode){
      formIsValid = false;
      errors["zipcode"] = "Please enter zip code";

    }else if(this.state.zipcode.length!==5){
      formIsValid = false;
      errors["zipcode"] = "Please enter 5 digits zip code";

    }
    // if(!this.state.phone){
    //   formIsValid = false;
    //   errors["phone"] = "Please enter contact number";

    // }else if(this.state.phone.length!==10){
    //   formIsValid = false;
    //   errors["phone"] = "Please enter 10 digits contact number";

    // }
    if(this.state.profile_image === undefined && this.state.prev_logo === ''){
      formIsValid = false;
      errors["profile_image"] = "Please choose profile image";

    }
    this.setState({errors: errors});
    return formIsValid;
  }

  
  /** Validations */
  handleValidation(){

    console.log(this.state.phone);

    console.log(this.state.phone.length);
    let errors = {};
    let formIsValid = true;
   /* if(!this.state.address2){
      formIsValid = false;
      errors["address2"] = "Please enter address2";
    }*/

    if(this.state.profile_image && this.state.profile_image.name && !this.state.profile_image.name.match(/.(jpg|jpeg|png)$/i)){
      formIsValid = false;
      errors["profile_image"] = "Please select valid image (Ex: jpg | jpeg | png )";
    }

	  if(this.state.profile_image === undefined && this.state.prev_logo === ''){
      formIsValid = false;
      errors["profile_image"] = "Please choose profile image";
      ReactDOM.findDOMNode(this.refs.profile_image).focus();

    }
    console.log("lenght",this.state.phone.length)
    if(!this.state.phone || this.state.phone == 'undefined'){
      formIsValid = false;
      errors["phone"] = "Please enter contact number";
      ReactDOM.findDOMNode(this.refs.phone).focus();

    }else if(this.state.phone.length < 10){
      formIsValid = false;
      errors["phone"] = "Please enter 10 digits contact number";
      ReactDOM.findDOMNode(this.refs.phone).focus();

    }

    if(!this.state.zipcode){
      formIsValid = false;
      errors["zipcode"] = "Please enter zip code";
      ReactDOM.findDOMNode(this.refs.zipcode).focus();

    }else if(this.state.zipcode.length!==5){
      formIsValid = false;
      errors["zipcode"] = "Please enter 5 digits zip code";
      ReactDOM.findDOMNode(this.refs.zipcode).focus();

    }
    if(!this.state.state){
      formIsValid = false;
      errors["state"] = "Please enter state";
      ReactDOM.findDOMNode(this.refs.state).focus();

    }
    if(!this.state.city){
      formIsValid = false;
      errors["city"] = "Please enter city";
      ReactDOM.findDOMNode(this.refs.city).focus();

    }
    if(!this.state.address1){
      formIsValid = false;
      errors["address1"] = "Please enter address";
      ReactDOM.findDOMNode(this.refs.address1).focus();

    }


    if(!this.state.lastname){
      formIsValid = false;
      errors["lastname"] = "Please enter last name";
      ReactDOM.findDOMNode(this.refs.lastname).focus();

    }
    if(!this.state.firstname){
      formIsValid = false;
      errors["firstname"] = "Please enter first name";
      ReactDOM.findDOMNode(this.refs.firstname).focus();

    }
  /* if(!this.state.gender){
      formIsValid = false;
      errors["gender"] = "Please enter gender";
    }*/

    this.setState({errors: errors});
    return formIsValid;
  }

  handleSubmit = event => {
    event.preventDefault();
    // console.log("phone",this.state.phone)

     if(this.handleValidation()){
      var str =this.state.phone; 
      var res = str.substr(0, 3);
      var res1 = str.substr(3, 3);
      var res2 = str.substr(6, 4);
      var contactnumber="("+res+")"+" "+res1+"-"+res2;
      this.setState({loading:1});
    let formData = new FormData();
        formData.append('profile_image',this.state.profile_image);
        formData.append('id',this.props.auth.user._id);
        formData.append('firstname', this.state.firstname);
        formData.append('lastname', this.state.lastname);
        formData.append('address1', this.state.address1);
        formData.append('phone', contactnumber);
        formData.append('gender', this.state.gender);
        formData.append('address2', this.state.address2);
        formData.append('country', this.state.country);
        formData.append('state', this.state.state);
        formData.append('city', this.state.city);
        formData.append('zipcode', this.state.zipcode);
        formData.append('prev_logo', this.state.prev_logo);
        // formData.append('profile_image', this.state.profile_image);
        formData.append('old_img', this.state.old_img);
        formData.append('view_logo', this.state.view_logo);

        const config = {
          headers: {
              'content-type': 'multipart/form-data'
          }
      };
    
    this.props.updateProfile(formData,config,this.props.history);

		//  axios.post(AppConstants.API+'/users/updateAdminprofile',formData)
		// 	.then(res => {   
		// 	 if(res.data.status === "success"){
		// 	  setTimeout((e) => {
    //       this.props.history.push('/dashboard');
    //       this.setState({
    //         loading:'',
    //       //errMsg: res.data.msg
    //       errMsg: (<div className="alert alert-success fade show mt-3">{res.data.msg}</div>)
    //       });
		// 	  }, 2000);
			 
		// 	  setTimeout(() => {
		// 		this.setState({
    //       errMsg: (<div className="alert alert-success fade show mt-3">{res.data.msg}</div>)
		// 		  //errMsg: false,
		// 		});
		// 	  }, 1000);
		// 	}
		// 	else{
		// 	  this.setState({
    //       loading:'',
    //     //errMsg: res.data.msg
    //     errMsg: (<div className="alert alert-danger fade show mt-3">{res.data.msg}</div>)
		// 	  });
		// 	}
		//   });
    } 
  };  

  componentDidMount() {
    this.props.getProfile(this.props.auth.user._id)
    // const that = this; 
    // fetch(AppConstants.API+'/users/profile/'+this.props.auth.user._id)
    // .then(function(res) {
    //   if(res.status === 200){
    //     return res.json();
    //   }
    // })
    // .then(function(data) {
    //   if(data.Status === "Success"){
    //     that.setState({
    //       firstname:data.data.firstname,
    //       lastname:data.data.lastname,
    //       email:data.data.email,
    //       profile_image:data.data.profile_image,
    //       address1:data.data.address1,
    //       phone:data.data.phone,
    //      // gender:data.data.gender,
    //       //address2: data.data.address2,
    //       //country: data.data.country,
    //       state: data.data.state,
    //       city: data.data.city,
    //       zipcode: data.data.zipcode,
    //       //view_logo: data.data.view_logo,
    //       //prev_logo: data.data.prev_logo,
    //       view_logo:data.data.profile_image,
		//   old_img:data.data.profile_image,
    //     });
    //   }else
    //   {
    //     console.log('invalid data')
    //   }
    // });
  }

  componentWillReceiveProps(nextProps) {
    console.log(nextProps.auth);   

		if(nextProps.auth.isAuthenticated) {        
        this.setState({
            id:nextProps.auth.user._id,
            firstname:nextProps.auth.user.firstname,
          lastname:nextProps.auth.user.lastname,
          email:nextProps.auth.user.email,
          profile_image:nextProps.auth.user.profile_image,
          address1:nextProps.auth.user.address1,
          phone:nextProps.auth.user.phone,
         // gender:nextProps.auth.user.gender,
          //address2: nextProps.auth.user.address2,
          //country: nextProps.auth.user.country,
          state: nextProps.auth.user.state,
          city: nextProps.auth.user.city,
          zipcode: nextProps.auth.user.zipcode,
          //view_logo: nextProps.auth.user.view_logo,
          //prev_logo: nextProps.auth.user.prev_logo,
          view_logo:nextProps.auth.user.profile_image,
		      old_img:nextProps.auth.user.profile_image
          });
        }        
      if (nextProps.errors)
      {
        this.setState({ errors: nextProps.errors });
      }
    }
  
  
  render() {
	// if(this.state.view_logo === '')
	// {
	// 	image = "https://s3-us-west-2.amazonaws.com/clayandland/5bd2fe11a4fac1656a8196c1/profile_images/1542016116518.png"
	// }
	// else if(this.state.prev_logo === '')
	// {
	// 	image =AppConstants.API+'/public/uploads/'+this.state.view_logo
	// }else{
	// 	image =this.state.prev_logo
  // }
  
  let image;
	if(this.state.profile_image == '')
	{
		image = placeholderimg;
	}else if(this.state.prev_logo == ''){
		image = this.state.profile_image;
	} else{
    image = this.state.prev_logo;
  }
    const { phone } = this.state;  
  return (
    <Page title="Edit Profile">
    <ul className="cst-breadcrumb">
        <li><Link to={'/dashboard'}>Home</Link></li>
        <li>Edit Profile</li>
    </ul>
    <ReactTitle title="Edit Profile"/>
      <Row>
        <Col xl={12} lg={12} md={12}>
          <Card>
            <CardBody>
              <Form name="changeadminpassword" onSubmit= { this.handleSubmit }>
                <FormGroup row>
                  <Label for="examplePassword" sm={2}>
                    First Name <span className="error">*</span>
                  </Label>
                  <Col sm={10}>
                    <Input
                      type="text"
                      ref = "firstname"
                      name="firstname"
                      placeholder="First Name"                      
                      value={this.state.firstname}
                      onChange={ this.handleInputChange }
                      onKeyUp={this.handleKeyUp}                 
                  
                    />
                    <span className="error" style={{color: 'red'}}>{this.state.errors["firstname"]}</span>
                  </Col>
                </FormGroup>
                <FormGroup row>
                  <Label for="examplePassword" sm={2}>
                    Last Name <span className="error">*</span>
                  </Label>
                  <Col sm={10}>
                    <Input
                      type="text"
                      name="lastname"
                      ref = "lastname"
                      placeholder="Last Name"                      
                      value={this.state.lastname}
                      onChange={ this.handleInputChange } 
                      onKeyUp={this.handleKeyUp}                 
                 
                    />
                    <span className="error" style={{color: 'red'}}>{this.state.errors["lastname"]}</span>
                  </Col>
                </FormGroup>
                <FormGroup row>
                  <Label for="examplePassword" sm={2}>
                    Email <span className="error">*</span>
                  </Label>
                  <Col sm={10}>
                    <Input
                      type="text"
                      name="email"
                      ref = "email"
                      onKeyUp={this.handleKeyUp}        
                      value={this.state.email}
                      readOnly  
                      disabled               
                    />                    
                  </Col>
                </FormGroup>
                <FormGroup row>
                  <Label for="examplePassword" sm={2}>
                  Contact Number <span>*</span>
                  </Label>
                  <Col sm={10}>
                    <NumberFormat
					  format="(###) ###-####"
					  mask=""
            name="phone"
            ref = "phone"
            onKeyUp={this.handleKeyUp}                 


					  placeholder="Contact Number"
					  onValueChange={this.inputChangedHandlerContact} className="form-control" 
					  value={phone}
					/>    
                    <span className="error" style={{color: 'red'}}>{this.state.errors["phone"]}</span>
                  </Col>
                </FormGroup> 
               { /*<FormGroup row>
                  <Label for="examplePassword" sm={2}>
                    Gender
                  </Label>
                  <Col sm={10}>
                    <Input
                      type="text"
                      name="gender"
                      placeholder="gender"
                      value={this.state.gender}
                      onChange={ this.handleInputChange }                     
                    />
                    <span className="error" style={{color: 'red'}}>{this.state.errors["gender"]}</span>
                  </Col>
                </FormGroup> */ }
                <FormGroup row>
                  <Label for="examplePassword" sm={2}>
                    Address <span className="error">*</span>
                  </Label>
                  <Col sm={10}>
                    <Input
                      type="text"
                      name="address1"
                      ref = "address1"
                      onKeyUp={this.handleKeyUp}                 

                      placeholder="Address"                     
                      value={this.state.address1}
                      onChange={ this.handleInputChange }                      
                    />
                    <span className="error" style={{color: 'red'}}>{this.state.errors["address1"]}</span>
                  </Col>
                </FormGroup>
                { /*<FormGroup row>
                  <Label for="examplePassword" sm={2}>
                    Address2
                  </Label>
                  <Col sm={10}>
                    <Input
                      type="text"
                      name="address2"
                      placeholder="address2"                     
                      value={this.state.address2}
                      onChange={ this.handleInputChange }                      
                    />
                    <span className="error" style={{color: 'red'}}>{this.state.errors["address2"]}</span>
                  </Col>
                </FormGroup>
                <FormGroup row>
                  <Label for="examplePassword" sm={2}>
                    Country
                  </Label>
                  <Col sm={10}>
                    <Input
                      type="text"
                      name="country"
                      placeholder="country"                     
                      value={this.state.country}
                      onChange={ this.handleInputChange }                      
                    />
                    <span className="error" style={{color: 'red'}}>{this.state.errors["country"]}</span>
                  </Col>
                </FormGroup>*/ }
                <FormGroup row>
                  <Label for="examplePassword" sm={2}>
                    City <span className="error">*</span>
                  </Label>
                  <Col sm={10}>
                    <Input
                      type="text"
                      name="city"
                      ref = "city"
                      onKeyUp={this.handleKeyUp}                 

                      placeholder="City"                     
                      value={this.state.city}
                      onChange={ this.handleInputChange }                      
                    />
                    <span className="error" style={{color: 'red'}}>{this.state.errors["city"]}</span>
                  </Col>
                </FormGroup>

                <FormGroup row>
                  <Label for="examplePassword" sm={2}>
                    State <span className="error">*</span>
                  </Label>
                  <Col sm={10}>
                    <Input
                      type="select"
                      name="state"
                      ref = "state"
                      onKeyUp={this.handleKeyUp}                 

                      placeholder="State"                     
                      value={this.state.state}
                      onChange={ this.handleInputChange }                      
                    >
                      <option value="">Select State</option>
                    <option value="Alabama">Alabama</option>
                    <option value="Alaska">Alaska</option>
                    <option value="Arizona">Arizona</option>
                    <option value="Arkansas">Arkansas</option>
                    <option value="California">California</option>
                    <option value="Colorado">Colorado</option>
                    <option value="Connecticut">Connecticut</option>
                    <option value="Delaware">Delaware</option>
                    <option value="District Of Columbia">District Of Columbia</option>
                    <option value="Florida">Florida</option>
                    <option value="Georgia">Georgia</option>
                    <option value="Hawaii">Hawaii</option>
                    <option value="Idaho">Idaho</option>
                    <option value="Illinois">Illinois</option>
                    <option value="Indiana">Indiana</option>
                    <option value="Iowa">Iowa</option>
                    <option value="Kansas">Kansas</option>
                    <option value="Kentucky">Kentucky</option>
                    <option value="Louisiana">Louisiana</option>
                    <option value="Maine">Maine</option>
                    <option value="Maryland">Maryland</option>
                    <option value="Massachusetts">Massachusetts</option>
                    <option value="Michigan">Michigan</option>
                    <option value="Minnesota">Minnesota</option>
                    <option value="Mississippi">Mississippi</option>
                    <option value="Missouri">Missouri</option>
                    <option value="Montana">Montana</option>
                    <option value="Nebraska">Nebraska</option>
                    <option value="Nevada">Nevada</option>
                    <option value="New Hampshire">New Hampshire</option>
                    <option value="New Jersey">New Jersey</option>
                    <option value="New Mexico">New Mexico</option>
                    <option value="New York">New York</option>
                    <option value="North Carolina">North Carolina</option>
                    <option value="North Dakota">North Dakota</option>
                    <option value="Ohio">Ohio</option>
                    <option value="Oklahoma">Oklahoma</option>
                    <option value="Oregon">Oregon</option>
                    <option value="Pennsylvania">Pennsylvania</option>
                    <option value="Rhode Island">Rhode Island</option>
                    <option value="South Carolina">South Carolina</option>
                    <option value="South Dakota">South Dakota</option>
                    <option value="Tennessee">Tennessee</option>
                    <option value="Texas">Texas</option>
                    <option value="Utah">Utah</option>
                    <option value="Vermont">Vermont</option>
                    <option value="Virginia">Virginia</option>
                    <option value="Washington">Washington</option>
                    <option value="West Virginia">West Virginia</option>
                    <option value="Wisconsin">Wisconsin</option>
                    <option value="Wyoming">Wyoming</option>
                    </Input>
                    <span className="error" style={{color: 'red'}}>{this.state.errors["state"]}</span>
                  </Col>
                </FormGroup>
            
                <FormGroup row>
                  <Label for="examplePassword" sm={2}>
                    Zip Code <span className="error">*</span>
                  </Label>
                  <Col sm={10}>
                    <Input
                      type="text"
                      name="zipcode"
                      ref = "zipcode"
                      onKeyUp={this.handleKeyUp}                 

                      placeholder="Zip Code"                     
                      value={this.state.zipcode}
                      onChange={ this.handleInputChange }   onChange={this.onChangeNumberkey}                     
                    />
                    <span className="error" style={{color: 'red'}}>{this.state.errors["zipcode"]}</span>
                  </Col>
                </FormGroup>
                
                
                <FormGroup row>
                  <Label for="Profile Image" sm={2}>
                    Profile Image <span className="error">*</span>
                  </Label>
                  <Col sm={10}>
                   <Input type="hidden" name="old_img" value={this.state.old_img} onChange={ this.handleInputChange }/>
                <div className="cst-upload">
                   <img src={image} style={{width: 100, height: 100}} /> 
               
                    <div className="file-upload">
                  <Label for="upload" className="file-upload__label"><MdFileUpload/>&nbsp;upload Your Image</Label>
                  <Input  type="file"
                      name="profile_image"                  
                      onChange={ this.handleProfileImage  } 
                      onKeyUp={this.handleKeyUp}      
                      ref ="profile_image"  id="upload" className="file-upload__input"   />
                  </div>
                  </div>
                    <span className="error w-100 d-block" style={{color: 'red'}}>{this.state.errors["profile_image"]}</span>
                  </Col>
                </FormGroup>

                <FormGroup check row>
                  <Col sm={{ size: 10, offset: 2 }}>
                    <Button className="btn btn-primary" onClick={ this.handleSubmit }>Update <div style={this.state.loading ? {} : { display: 'none' }} className="image-fill w-25 loader-div"><img src={Loading} alt="No Image" className="can-click " /></div></Button>
                    &nbsp;
                    <Link to={"/viewadminprofile"} className="btn btn-danger" title="Cancel">{/* <MdAdd /> */}&nbsp;Cancel</Link>
                  </Col>
                </FormGroup>
                {this.state.errMsg}
              </Form>
            </CardBody>
          </Card>
        </Col>
      </Row>
     
    </Page>
  );
};
}

Editprofile.propTypes = {
  updateProfile: PropTypes.func.isRequired,
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired
};
const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors
});

//export default ChangepasswordPage;
export  default connect(mapStateToProps, {getProfile,updateProfile})(Editprofile);
